// Notification types matching backend
export interface NotificationResponse {
    id: string;
    companyUserId: string | null;
    type: string;
    priority: string;
    title: string;
    message: string;
    actionUrl: string | null;
    isRead: boolean;
    readAt: string | null;
    relatedEntityId: string | null;
    relatedEntityType: string | null;
    createdAt: string;
    /** Last time this row's content changed, e.g. when a collapsed notification gained a new occurrence. */
    updatedAt: string | null;
    /** Number of occurrences collapsed into this row, e.g. 3 for "3 new comments". */
    occurrenceCount: number;
}

export interface PagedResponse<T> {
    items: T[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export enum NotificationPriority {
    Normal = 'Normal',
    High = 'High',
    Urgent = 'Urgent',
}
